import React, { useEffect } from 'react'
import useWindowDimensions from 'src/hooks/useWindowDimensions'
import { useErrorComponentEvent } from 'src/sdk/analytics/hooks/useErrorComponentEvent'
import errorFunction from 'src/utils/error/errorFunction'

type Props = {
  heightMobile?: string
  heightDesktop?: string
}

function SpaceBetweenSections(props: Readonly<Props>) {
  const dimensionsConfig = {
    heightMobile: props?.heightMobile ?? '48',
    heightDesktop: props?.heightDesktop ?? '56',
  }

  const { heightDesktop, heightMobile } = dimensionsConfig
  const { isMobile } = useWindowDimensions()

  const { sendErrorComponentEvent } = useErrorComponentEvent(
    'SpaceBetweenSections'
  )

  useEffect(() => {
    if (!props) {
      errorFunction(props, 'SpaceBetweenSections', sendErrorComponentEvent)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!props) {
    return <></>
  }

  return (
    <div style={{ height: `${isMobile ? heightMobile : heightDesktop}px` }} />
  )
}

export default SpaceBetweenSections
